import type { Router } from "vue-router";
import { checkVersion } from "@/router/guards/checkVersion";
import { handleInvalidTokenFound } from "@/router/guards/handleInvalidTokenFound";
import { handleLogin } from "@/router/guards/handleLogin";
import { handleRedirectForLoggedInUser } from "@/router/guards/handleRedirectForLoggedInUser";
import { setLinkAlternate } from "@/router/guards/setLinkAlternate";
import { setUserPreferredLocalization } from "@/router/guards/setUserPreferredLocalization";
import { startupUserCheck } from "@/router/guards/startupUserCheck";
import { storeLocalizationInApp } from "@/router/guards/storeLocalizationInApp";
import { registerDynamicImportRecovery } from "@/router/dynamicImportRecovery";

export function registerGuards(router: Router): void {
  router.beforeEach(startupUserCheck);
  router.beforeEach(checkVersion);
  router.beforeEach(storeLocalizationInApp);
  router.beforeEach(handleInvalidTokenFound);
  router.beforeEach(setUserPreferredLocalization);
  router.beforeEach(handleLogin);
  router.beforeEach(handleRedirectForLoggedInUser);

  router.afterEach(setLinkAlternate);

  registerDynamicImportRecovery(router);
}
